import { useState } from "react";
import { X } from "lucide-react";
import FileUpload from "@/components/churchbuilder/FileUpload";

export const inp = "w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2.5 rounded text-sm text-white";
export const lbl = "text-[10px] tracking-widest uppercase text-neutral-400 block mb-1";

const BLANK = {
  title: "", description: "", image_url: "", category: "", pricing_type: "none", price_label: "",
  destination_url: "", cta_label: "Explore", status: "draft", featured: false, new_release: false, coming_soon: false, order: 0,
};

export default function ListingForm({ initial, categories, onSave, onClose }) {
  const [f, setF] = useState({ ...BLANK, category: categories[0]?.key || "", ...initial });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = (e) => { e.preventDefault(); onSave({ ...f, order: Number(f.order) || 0 }); };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-start justify-center overflow-y-auto p-4" data-testid="mkt-listing-form">
      <form onSubmit={submit} className="w-full max-w-3xl bg-[#111] border border-white/10 rounded-xl p-6 lg:p-8 my-10">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-serif-display text-3xl text-white">{f.id ? "Edit listing" : "New listing"}</h3>
          <button type="button" onClick={onClose} aria-label="Close" data-testid="mkt-form-close" className="text-neutral-400 hover:text-white"><X size={20} /></button>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="md:col-span-2"><label className={lbl}>Title *</label><input required data-testid="mkt-form-title" className={inp} value={f.title} onChange={set("title")} /></div>
          <div className="md:col-span-2"><label className={lbl}>Description</label><textarea rows={3} data-testid="mkt-form-description" className={inp} value={f.description} onChange={set("description")} /></div>
          <div>
            <label className={lbl}>Category *</label>
            <select required data-testid="mkt-form-category" className={inp} value={f.category} onChange={set("category")}>
              {categories.map((c) => <option key={c.key} value={c.key}>{c.name}</option>)}
            </select>
          </div>
          <div>
            <label className={lbl}>Status</label>
            <select data-testid="mkt-form-status" className={inp} value={f.status} onChange={set("status")}>
              <option value="draft">Draft</option><option value="published">Published</option><option value="archived">Archived</option>
            </select>
          </div>
          <div>
            <label className={lbl}>Pricing type</label>
            <select data-testid="mkt-form-pricing-type" className={inp} value={f.pricing_type} onChange={set("pricing_type")}>
              <option value="none">None</option><option value="one_off">One-off price</option>
              <option value="subscription">Subscription</option><option value="free">Free</option>
            </select>
          </div>
          <div><label className={lbl}>Price / subscription label</label><input data-testid="mkt-form-price-label" placeholder="e.g. From £5/mo" className={inp} value={f.price_label} onChange={set("price_label")} /></div>
          <div className="md:col-span-2">
            <label className={lbl}>Destination URL</label>
            <input data-testid="mkt-form-destination" placeholder="/church-builder or https://www.hohvibesshop.com/..." className={inp} value={f.destination_url} onChange={set("destination_url")} />
            <p className="text-[11px] text-neutral-500 mt-1">Start with “/” for a page on this site, or “https://” for Shopify, app stores or payment links (opens in a new tab).</p>
          </div>
          <div><label className={lbl}>Button label</label><input data-testid="mkt-form-cta" className={inp} value={f.cta_label} onChange={set("cta_label")} /></div>
          <div><label className={lbl}>Order</label><input type="number" data-testid="mkt-form-order" className={inp} value={f.order} onChange={set("order")} /></div>
          <div className="md:col-span-2">
            <FileUpload value={f.image_url} onChange={(url) => setF({ ...f, image_url: url })} label="Image (16:9 recommended)" testid="mkt-form-image" />
            <input data-testid="mkt-form-image-url" placeholder="…or paste an image URL" className={`${inp} mt-2`} value={f.image_url} onChange={set("image_url")} />
          </div>
          <div className="md:col-span-2 flex flex-wrap gap-6 pt-2">
            {[["featured", "Featured"], ["new_release", "New release"], ["coming_soon", "Coming soon"]].map(([k, l]) => (
              <label key={k} className="flex items-center gap-2 text-sm text-neutral-300">
                <input type="checkbox" data-testid={`mkt-form-${k}`} checked={!!f[k]} onChange={set(k)} className="accent-[#D4AF37]" /> {l}
              </label>
            ))}
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-8">
          <button type="button" onClick={onClose} className="px-5 py-2.5 rounded text-xs tracking-widest uppercase text-neutral-300 border border-white/15 hover:border-white/40">Cancel</button>
          <button type="submit" data-testid="mkt-form-save" className="btn-gold px-6 py-2.5 rounded text-xs tracking-widest uppercase font-semibold">Save listing</button>
        </div>
      </form>
    </div>
  );
}
